import {getLoginPassword} from '@/api/login';
import {setToken, getInstanceId, setInstanceId} from '@/utils/auth';
import Cookies from "js-cookie";

const user = {
  state: {
    token: '',
    name: '用户',
    avatar: require('@/assets/images/profile.jpg'),
    instanceId: getInstanceId() || '',
    instanceAreaCode: Cookies.get('instanceAreaCode') || '',
    msgContentShowType: 'base64',
    consumerLogContentShowType: 'base64',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_InstanceId: (state, instanceId) => {
      state.instanceId = instanceId;
    },
    setInstanceAreaCode: (state, instanceAreaCode) => {
      state.instanceAreaCode = instanceAreaCode;
    },
    setMsgContentShowType: (state, msgContentShowType) => {
      state.msgContentShowType = msgContentShowType;
    },
    setConsumerLogContentShowType: (state, consumerLogContentShowType) => {
      state.consumerLogContentShowType = consumerLogContentShowType;
    },
  },

  actions: {
    UpdateInstanceId({commit}, instanceId){
      setInstanceId(instanceId); // 存入cookies
      commit('SET_InstanceId', instanceId); // 存入vuex
    },
    UpdateInstanceAreaCode({commit}, instanceAreaCode){
      Cookies.set('instanceAreaCode', instanceAreaCode); // 存入cookies
      commit('setInstanceAreaCode', instanceAreaCode); // 存入vuex
    },
    // 登录
    Login({commit}, userInfo){
      const account = userInfo.account.trim();
      const password = userInfo.password;

      return new Promise((resolve, reject) => {
        getLoginPassword(account, password)
          .then((res) => {
            setToken(res.data);
            commit('SET_TOKEN', res.data);
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default user;
